import { Box, Color } from '@gousto-internal/citrus-react'
import { Recipe } from '@library/menu-service'
import React, { RefObject } from 'react'
import { LandingPageContent } from '../../../landing-page-content/src/LandingPageContent'
import { Hero, ThreeStepHero } from '../components'
import { useFetchRafCampaignDetails } from '../hooks/useFetchRafCampaignDetails'
import {
  EnvironmentalBenefitsSection,
  ValueYouCanTasteSection,
  HowItWorksSection,
} from '@library/landing-pages'
export type RafLandingPageType = {
  onScrollHandler: ({
    heroRef,
    stickyCTARef,
    setIsSticky,
    setMaxHeight,
  }: {
    heroRef: RefObject<HTMLDivElement>
    stickyCTARef: RefObject<HTMLDivElement>
    setIsSticky: (isSticky: boolean) => void
    setMaxHeight: (isSticky: number) => void
  }) => void
  onSignupCTAClick: () => void
  recipes: Recipe[]
  signupCTA: string
}

export const RafLandingPage = ({
  onScrollHandler,
  onSignupCTAClick,
  recipes,
  signupCTA,
}: RafLandingPageType) => {
  const { firstBoxDiscount, firstMonthDiscount, secondBoxDiscount, giftYourFriendCredit } =
    useFetchRafCampaignDetails()

  const isThreeStepHeroEnabled = !!secondBoxDiscount

  return (
    <Box paddingBottom={[10, 6]} bg={Color.White}>
      {isThreeStepHeroEnabled && (
        <ThreeStepHero
          firstBoxDiscount={firstBoxDiscount}
          firstMonthDiscount={firstMonthDiscount}
          secondBoxDiscount={secondBoxDiscount}
          giftYourFriendCredit={giftYourFriendCredit}
          onScrollHandler={onScrollHandler}
          onCTAClick={onSignupCTAClick}
          signupCTA={signupCTA}
        />
      )}
      {!isThreeStepHeroEnabled && (
        <Hero
          firstBoxDiscount={firstBoxDiscount}
          firstMonthDiscount={firstMonthDiscount}
          giftYourFriendCredit={giftYourFriendCredit}
          onScrollHandler={onScrollHandler}
          onCTAClick={onSignupCTAClick}
          signupCTA={signupCTA}
        />
      )}
      <HowItWorksSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
      <ValueYouCanTasteSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
      <LandingPageContent
        onSignupCTAClick={onSignupCTAClick}
        signupCTA={signupCTA}
        recipes={recipes}
      />
      <EnvironmentalBenefitsSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
    </Box>
  )
}
